/* unplugin-vue-components disabled */import script from "./DownloadCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCenter.vue?vue&type=script&setup=true&lang=js"

import "./DownloadCenter.vue?vue&type=style&index=0&id=c00b6b50&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00b6b50"]])

export default __exports__